import useWindowSize from './useWindowSize';


const MOBILE_WIDTH = 870;


/**
 * Checks if the window is currently in a mobile size.
 * @param {number} width The width of the window.
 * @return True if the width is less than the MOBILE_WIDTH size.
 */
function isMobileSize(width) {
  return width < MOBILE_WIDTH;
}

/**
 * A hook for checking if the window is currently in a mobile size.
 * @return True if the window is less than the MOBILE_WIDTH size.
 */
export default function useIsMobileSize() {
  const [width] = useWindowSize();

  return isMobileSize(width);
}
